import { Injectable } from "@angular/core";
import { Router, NavigationEnd } from "@angular/router";
import { filter } from "rxjs/operators";
import { environment } from "../../environments/environment";

declare global {
  interface Window {
    dataLayer: unknown[];
    gtag: (...args: unknown[]) => void;
  }
}

@Injectable({ providedIn: "root" })
export class AnalyticsService {
  private measurementId: string | undefined;

  constructor(private router: Router) {
    this.measurementId =
      (environment as { googleAnalyticsId?: string }).googleAnalyticsId ??
      (environment as { google?: { measurementId?: string } }).google?.measurementId;

    if (this.measurementId) {
      this.loadGtag();
      this.trackRouteChanges();
    }
  }

  private loadGtag(): void {
    window.dataLayer = window.dataLayer || [];
    window.gtag = function gtag(...args: unknown[]) {
      window.dataLayer.push(args);
    };
    window.gtag("js", new Date());

    const script = document.createElement("script");
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${this.measurementId}`;
    document.head.appendChild(script);

    script.onload = () => {
      window.gtag("config", this.measurementId);
    };
  }

  private trackRouteChanges(): void {
    this.router.events
      .pipe(filter((e): e is NavigationEnd => e instanceof NavigationEnd))
      .subscribe((e) => {
        if (this.measurementId) {
          window.gtag("config", this.measurementId, {
            page_path: e.urlAfterRedirects,
          });
        }
      });
  }
}
